<template>
  <div class="event-filters"
       :class="{'--active':openPopup}"
       v-on-click-away="hidePopup">
    <input type="text"
           readonly
           v-model="selectedEventsLength"
           @click="openPopup = !openPopup">
    <div class="label">События</div>
    <div class="icon">
      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.6098 5.83709L0.159755 1.29221C0.0567475 1.1871 -4.5756e-08 1.04677 -3.92158e-08 0.897152C-3.26756e-08 0.74753 0.0567475 0.607207 0.159755 0.50209L0.487394 0.167391C0.700889 -0.0503998 1.04788 -0.0503998 1.26105 0.167391L4.99793 3.98384L8.73895 0.163157C8.84196 0.0580392 8.97928 3.92497e-07 9.1257 3.98897e-07C9.27228 4.05304e-07 9.4096 0.0580392 9.51269 0.163157L9.84025 0.497855C9.94325 0.603056 10 0.743296 10 0.892918C10 1.04254 9.94325 1.18286 9.84025 1.28798L5.38613 5.83709C5.2828 5.94246 5.14484 6.00033 4.99817 6C4.85094 6.00033 4.71305 5.94246 4.6098 5.83709Z"
            fill="#AEC1D4"/>
      </svg>
    </div>
    <div class="event-filters__popup" v-if="openPopup">
      <div class="grid grid-cols-2 col-gap-10 mb-12">
        <BaseToggle :checked="eventFilter.buy.checked"
                    @change="toggleEventFilter('buy')">
          {{ eventFilter.buy[`label_${$i18n.locale}`] }}
        </BaseToggle>
        <BaseToggle :checked="eventFilter.sell.checked"
                    @change="toggleEventFilter('sell')">
          {{ eventFilter.sell[`label_${$i18n.locale}`] }}
        </BaseToggle>
      </div>
      <div class="grid grid-cols-2 col-gap-10 row-gap-6 mb-12">
        <BaseToggle :checked="eventFilter.dividend.checked"
                    @change="toggleEventFilter('dividend')">
          {{ eventFilter.dividend[`label_${$i18n.locale}`] }}
        </BaseToggle>

        <BaseToggle :checked="eventFilter.coupon.checked"
                    @change="toggleEventFilter('coupon')">
          {{ eventFilter.coupon[`label_${$i18n.locale}`] }}
        </BaseToggle>
        <BaseToggle :checked="eventFilter.amortization.checked"
                    @change="toggleEventFilter('amortization')">
          {{ eventFilter.amortization[`label_${$i18n.locale}`] }}
        </BaseToggle>
      </div>
      <div class="grid grid-cols-2 col-gap-10 mb-12">
        <BaseToggle :checked="eventFilter.deposit.checked"
                    @change="toggleEventFilter('deposit')">
          {{ eventFilter.deposit[`label_${$i18n.locale}`] }}
        </BaseToggle>
        <BaseToggle :checked="eventFilter.withdraw.checked"
                    @change="toggleEventFilter('withdraw')">
          {{ eventFilter.withdraw[`label_${$i18n.locale}`] }}
        </BaseToggle>
      </div>
      <div class="grid grid-cols-2 col-gap-10">
        <BaseToggle :checked="eventFilter.commission.checked"
                    @change="toggleEventFilter('commission')">
          {{ eventFilter.commission[`label_${$i18n.locale}`] }}
        </BaseToggle>
        <BaseToggle :checked="eventFilter.tax.checked"
                    @change="toggleEventFilter('tax')">
          {{ eventFilter.tax[`label_${$i18n.locale}`] }}
        </BaseToggle>
      </div>
    </div>
  </div>
</template>

<script>
import BaseToggle from "@/components/UI/BaseToggle";
import {directive as onClickAway} from "vue-clickaway";
import {mapMutations, mapState} from "vuex";

export default {
  name: "DealsFiltersEvents",
  directives: {
    onClickAway: onClickAway
  },
  components: {BaseToggle},
  data() {
    return {
      openPopup: false,
    }
  },
  computed: {
    ...mapState('investments/deals', ['filters']),
    eventFilter() {
      return this.filters.event_type;
    },
    selectedEventsLength() {
      const selected = Object.keys(this.eventFilter)
          .filter(item => this.eventFilter[item].checked ).length
      return `Выбрано: ${selected}`
    },
  },
  methods: {
    ...mapMutations('investments/deals', ['toggleEventFilter']),
    hidePopup() {
      this.openPopup = false;
    }
  }
}
</script>

<style scoped lang="scss">
.event-filters {
  position: relative;

  input {
    @apply bg-block border border-border rounded shadow-input
    px-5-6 py-4-5 w-full cursor-pointer
    text-md text-text-secondary outline-none;
    transition: all .2s;

    &:focus {
      @apply border-border-hover;
    }
  }

  .label {
    @apply text-xs text-text-label px-5-6 top-0 transform -translate-y-1/2 absolute z-10 ;
    //@apply text-md text-text-ternary   pt-4-5   cursor-text;
    transition: all .2s;

    &:before {
      @apply bg-block left-2;
      content: '';
      position: absolute;
      right: 0;
      top: 35%;
      width: calc(100% - 1rem);
      height: 9px;
      filter: blur(3px);
      z-index: -1;
    }
  }

  .icon {
    @apply absolute right-0 top-0 px-5
    h-full flex items-center
    transform origin-center transition duration-200;
  }

  &__popup {
    @apply absolute z-100 bottom-0
    bg-block w-full p-6
    border border-border-hover rounded-b border-t-0
    transform translate-y-full;
  }

  &:hover {
    input {
      @apply border-border-hover;
    }
  }

  &.--active {
    .icon {
      @apply rotate-180;
    }

    input {
      @apply rounded-t rounded-b-none;
    }
  }
}
</style>